var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4.10982L13.51 2.23982C12.68 1.92982 11.32 1.92982 10.49 2.23982L5.50003 4.10982C4.35003 4.53982 3.41003 5.89982 3.41003 7.11982V14.5498C3.41003 15.7298 4.19003 17.2798 5.14003 17.9898L9.44003 21.1998C10.85 22.2598 13.17 22.2598 14.58 21.1998L18.88 17.9898C19.83 17.2798 20.61 15.7298 20.61 14.5498V7.11982C20.59 5.89982 19.65 4.53982 18.5 4.10982ZM11.93 7.02982C13.11 7.02982 14.07 7.98982 14.07 9.16982C14.07 10.3298 13.16 11.2598 12.01 11.2998H11.99H11.97C11.95 11.2998 11.93 11.2998 11.91 11.2998C10.71 11.2598 9.81003 10.3298 9.81003 9.16982C9.80003 7.98982 10.76 7.02982 11.93 7.02982ZM14.19 16.3598C13.58 16.7598 12.79 16.9698 12 16.9698C11.21 16.9698 10.41 16.7698 9.81003 16.3598C9.24003 15.9798 8.93003 15.4598 8.92003 14.8898C8.92003 14.3298 9.24003 13.7898 9.81003 13.4098C11.02 12.6098 12.99 12.6098 14.2 13.4098C14.77 13.7898 15.09 14.3098 15.09 14.8798C15.08 15.4398 14.76 15.9798 14.19 16.3598Z",
    fill: "#7AC678"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminActive);
export default __webpack_public_path__ + "static/media/admin-active.534a8a785007238f9829a999dd22554e.svg";
export { ForwardRef as ReactComponent };